/* Cabrzy theme — cart drawer, variant pickers, gallery, home grid filters */
(() => {
  const cfg = window.Cabrzy || { routes: {} };
  const DRAWER_SECTION = 'cart-drawer';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Mirrors Liquid's money_without_trailing_zeros using the shop's money format.
  const formatMoney = cents => {
    const format = (cfg.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const group = (n, dec, thou, sep) => {
      const [whole, frac] = (cents / 100).toFixed(dec).split('.');
      const w = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return frac && Number(frac) !== 0 ? w + sep + frac : w;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- Cart drawer ---------- */
  let lastFocus = null;
  const openDrawer = () => {
    lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    const d = $('#CartDrawer');
    if (d) d.focus();
  };
  const closeDrawer = () => {
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const renderDrawer = html => {
    const wrap = document.getElementById('shopify-section-' + DRAWER_SECTION);
    if (!wrap || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('shopify-section-' + DRAWER_SECTION);
    wrap.innerHTML = fresh ? fresh.innerHTML : html;
    const countEl = $('[data-cart-count]', wrap);
    const count = countEl ? countEl.textContent.trim() : null;
    if (count !== null) $$('[data-cart-count]').forEach(el => { el.textContent = count; });
  };

  const cartRequest = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: [DRAWER_SECTION], sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong');
    if (data.sections) renderDrawer(data.sections[DRAWER_SECTION]);
    return data;
  };

  const addToCart = items => cartRequest(cfg.routes.cartAdd, { items });

  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(); return; }

    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer();
      // "Continue Shopping" is a link; only follow it when it leaves the page.
      if (closer.tagName === 'A' && closer.pathname === window.location.pathname) {
        e.preventDefault();
        const target = closer.hash && document.querySelector(closer.hash);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    const line = e.target.closest('[data-line-change]');
    if (line) {
      const drawer = $('#CartDrawer');
      if (drawer) drawer.classList.add('is-busy');
      try {
        await cartRequest(cfg.routes.cartChange, { id: line.dataset.lineChange, quantity: Number(line.dataset.qty) });
      } catch (err) {
        console.error(err);
        if (drawer) drawer.classList.remove('is-busy');
      }
      return;
    }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      try {
        await addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]);
        openDrawer();
      } catch (err) {
        console.error(err);
      } finally {
        quick.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer();
  });

  /* ---------- Variant forms (product page + bundles) ---------- */
  const initVariantForm = form => {
    const dataEl = $('script[data-variants]', form);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', form);
    const compareEl = $('[data-compare]', form);
    const addBtn = $('[data-add-button]', form);
    const buyNow = $('[data-buy-now]', form);
    const errorEl = $('[data-form-error]', form);
    const pills = $$('[data-option-index]', form);
    const isProductPage = !!form.closest('[data-product-section]');
    let current = variants.find(v => String(v.id) === idInput.value) || variants[0];
    const selected = current.options.slice();

    const syncPills = () => {
      pills.forEach(p => {
        const idx = Number(p.dataset.optionIndex);
        const on = selected[idx] === p.dataset.value;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
        // Mark values that can't be bought with the other current picks.
        const trial = selected.slice();
        trial[idx] = p.dataset.value;
        const match = variants.find(v => v.options.every((o, i) => o === trial[i]));
        p.classList.toggle('is-unavailable', !match || !match.available);
      });
      $$('[data-option-value]', form).forEach(el => { el.textContent = selected[Number(el.dataset.optionValue)]; });
    };

    const update = () => {
      current = variants.find(v => v.options.every((o, i) => o === selected[i]));
      syncPills();
      if (!current) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (buyNow) buyNow.disabled = true;
        return;
      }
      idInput.value = current.id;
      if (priceEl) priceEl.textContent = formatMoney(current.price);
      if (compareEl) {
        const onSale = current.compare_at_price && current.compare_at_price > current.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(current.compare_at_price);
      }
      if (addBtn) {
        addBtn.disabled = !current.available;
        const base = addBtn.dataset.label;
        addBtn.textContent = !current.available ? 'Sold Out'
          : addBtn.hasAttribute('data-price-in-label') ? `${base} — ${formatMoney(current.price)}` : base;
      }
      if (buyNow) buyNow.disabled = !current.available;
      if (isProductPage) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
        if (current.featured_media) showSlideByMediaId(current.featured_media.id);
      }
    };

    pills.forEach(p => p.addEventListener('click', () => {
      selected[Number(p.dataset.optionIndex)] = p.dataset.value;
      update();
    }));

    $$('[data-qty-step]', form).forEach(b => b.addEventListener('click', () => {
      const input = $('[data-qty-input]', form);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
    }));

    const submit = async () => {
      if (!current || !current.available) return false;
      const qtyInput = $('input[name="quantity"]', form);
      const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (errorEl) errorEl.hidden = true;
      try {
        await addToCart([{ id: current.id, quantity }]);
        return true;
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else console.error(err);
        return false;
      }
    };

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (addBtn) addBtn.classList.add('is-loading');
      const ok = await submit();
      if (addBtn) addBtn.classList.remove('is-loading');
      if (ok) openDrawer();
    });

    if (buyNow) buyNow.addEventListener('click', async () => {
      buyNow.classList.add('is-loading');
      const ok = await submit();
      buyNow.classList.remove('is-loading');
      if (ok) window.location.href = cfg.routes.checkout;
    });

    syncPills();
  };

  /* ---------- Product gallery ---------- */
  const gallery = $('[data-gallery]');
  const showSlide = i => {
    if (!gallery) return;
    $$('[data-slide]', gallery).forEach(s => { s.hidden = Number(s.dataset.slide) !== i; });
    $$('[data-thumb]', gallery).forEach(t => t.classList.toggle('is-active', Number(t.dataset.thumb) === i));
    const label = $('[data-photo-label]', gallery);
    if (label) label.textContent = `Product Photo ${i + 1} / ${$$('[data-thumb]', gallery).length}`;
  };
  const showSlideByMediaId = id => {
    const slide = gallery && $(`[data-media-id="${id}"]`, gallery);
    if (slide) showSlide(Number(slide.dataset.slide));
  };
  if (gallery) $$('[data-thumb]', gallery).forEach(t => t.addEventListener('click', () => showSlide(Number(t.dataset.thumb))));

  $$('[data-variant-form]').forEach(initVariantForm);

  /* ---------- Home "All In" filters ---------- */
  const grid = $('[data-filter-grid]');
  const applyFilter = handle => {
    if (!grid) return false;
    const tabs = $$('[data-filter-tab]', grid);
    const tab = tabs.find(t => t.dataset.filterTab === handle) || tabs[0];
    if (!tab) return false;
    tabs.forEach(t => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    const { match, matchValue } = tab.dataset;
    let shown = 0;
    $$('[data-product-card]', grid).forEach(card => {
      const ok = match === 'tag' ? card.dataset.tags.split(' ').includes(matchValue)
        : match === 'type' ? card.dataset.type === matchValue
        : true;
      card.hidden = !ok;
      if (ok) shown++;
    });
    const countEl = $('[data-filter-count]', grid);
    if (countEl && $$('[data-product-card]', grid).length) countEl.textContent = `${shown} ${shown === 1 ? 'Item' : 'Items'}`;
    return true;
  };
  if (grid) {
    $$('[data-filter-tab]', grid).forEach(t => t.addEventListener('click', () => applyFilter(t.dataset.filterTab)));
    const initial = new URLSearchParams(window.location.search).get('filter');
    if (initial) applyFilter(initial);
    // Header/footer "Shop All" and "Apparel" links filter in place when already on the home page.
    $$('[data-filter-link]').forEach(a => a.addEventListener('click', e => {
      if (a.pathname !== window.location.pathname) return;
      e.preventDefault();
      applyFilter(a.dataset.filterLink);
      const top = grid.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
    }));
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh) el.innerHTML = fresh.innerHTML;
    } catch (err) {
      console.error(err);
    }
  });
})();
